// Call the dataTables jQuery plugin
$(document).on('ready', function() {
  $('#datatable').DataTable({
    "bPaginate":true,
    "iDisplayLength": 10
  });
});
